let versionCheckInProgress = false;
export async function checkAppVersion(silent = false) {
  if (versionCheckInProgress) return;

  // Don't ask when there is nothing to ask. `navigator.onLine === false` is the
  // reliable direction of this flag — true can still mean a captive portal, but
  // false means the browser has no network at all, so the request can only fail.
  //
  // This matters more than it looks: `lazyWithRetry` awaits this before every
  // lazy route, and the rejection used to escape and take the whole app down
  // through the error boundary.
  if (navigator.onLine === false) return;

  versionCheckInProgress = true;

  try {
    const res = await fetch(`/version.json?v=${Date.now()}`, {
      cache: "no-store",
    });
    if (!res.ok) return;

    const { fullVersion } = await res.json();
    const current = localStorage.getItem("app-version");

    if (current && current !== fullVersion) {
      // Only update if it's actually different from what we are currently running
      localStorage.setItem("pending-version", fullVersion);

      if (!silent) {
        window.dispatchEvent(new Event("app-version-changed"));
      }
    } else if (!current) {
      localStorage.setItem("app-version", fullVersion);
    }
  } catch {
    // Online by the flag but the request still failed — captive portal, DNS,
    // or the server being down. A version poll failing is never a reason to
    // stop the app loading, so this is swallowed deliberately.
  } finally {
    versionCheckInProgress = false;
  }
}
